// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorBoundary__container___3VQxn{height:100%;width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;padding:10px}.errorBoundary__alertIcon___2LwbD{font-size:12px;color:#717070;width:30px}.errorBoundary__header___6H1O4{color:#222;font-weight:500;margin:20px;font-size:16px}.errorBoundary__subHeader___15F3I{color:#717070}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"container": "errorBoundary__container___3VQxn",
	"alertIcon": "errorBoundary__alertIcon___2LwbD",
	"header": "errorBoundary__header___6H1O4",
	"subHeader": "errorBoundary__subHeader___15F3I"
};
module.exports = exports;
